import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld,
      children: [
        {
          path: 'test',
          name: '测试',
          component: () => import('@/views/file-view/pdfPage')
        },
        {
          path: 'FileDelete',
          name: '删除',
          component: () => import('@/views/file-display/FileDelete')

        },
        {
          path: 'FileForbid',
          name: '禁止',
          component: () => import('@/views/file-display/FileForbid')

        },
        {
          path: 'c',
          name: 'code',
          component: () => import('@/views/code-view/CodeView')
        },
        {
          path: 'cx',
          name: 'codeHome',
          component: () => import('@/views/code-view/HomeView')
        },
        {
          path: '/stopParsing',
          name: 'stopParsing',
          component: () => import('@/views/code-view/StopParsing')
        },
        {
          path: '/check-code-history',
          component: () => import('../views/check-code-history/CheckCodeHistory')
        },
        {
          path: '/contact-us',
          component: () => import('../views/contact-us/ContactUs')
        },
        {
          path: '/instruction',
          component: () => import('../views/instruction/instruction')
        },
        {
          path: '/repair',
          component: () => import('../views/repair/Repair')
        },
        {
          path: '/warranty',
          component: () => import('../views/warranty/Warranty')
        },
        {
          path: '/warrantyAdd',
          component: () => import('../views/warranty/WarrantyAdd')
        },
        {
          path: '/warrantyBill',
          component: () => import('../views/warranty/WarrantyBill')
        },
        {
          path: '/warrantyRemark',
          component: () => import('../views/warranty/WarrantyRemark')
        },
        {
          path: '/image',
          component: (resolve) => require(['@/views/preview/image'], resolve),
          hidden: true
        },
        {
          path: '/video',
          component: (resolve) => require(['@/views/preview/video'], resolve),
          hidden: true
        },
        {
          path: '/audio',
          component: (resolve) => require(['@/views/preview/audio'], resolve),
          hidden: true
        },
        {
          path: '/pdf',
          component: (resolve) => require(['@/views/preview/pdf'], resolve),
          hidden: true
        },
        {
          path: '/page/:pageId',
          component: (resolve) => require(['@/views/preview/page'], resolve),
          hidden: true
        },
        {
          path: '/error',
          component: (resolve) => require(['@/views/error/Error'], resolve),
          hidden: true
        },
        {
          path: '/prodSource',
          name: 'prodSource',
          component: () => import('@/views/product/productSource')
        },
        {
          path: '/productInfo',
          name: 'productInfo',
          component: () => import('@/views/code-view/ProductInfo')
        },
        {
          path: '/home',
          name: 'homePage',
          meta: {
            keepAlive: true
          },
          component: () => import('@/views/home-page/home')
        },
        {
          path: '/qrImage',
          name: 'qrImage',
          component: () => import('@/views/home-page/qrImage')
        },
        {
          path: '/template/list',
          name: 'TemplateList',
          meta: {
            keepAlive: true
          },
          component: () => import('@/views/template/TemplateList')
        },
        {
          path: '/industryCase/list',
          name: 'industryCase',
          meta: {
            keepAlive: true
          },
          component: () => import('@/views/industryCase/industryCaseList')
        },
        {
          path: '/industryCase/detail',
          component: (resolve) => require(['@/views/industryCase/caseDetail'], resolve),
          hidden: true
        },
        {
          path: '/template/detail',
          name: 'TemplateDetail',
          component: () => import('@/views/template/TemplateDetail')
        },
        {
          path: '/share/template',
          name: 'TemplateShow',
          component: () => import('@/views/template/TemplateShow')
        },
        {
          path: '/policy/list',
          name: 'PolicyList',
          meta: {
            keepAlive: true
          },
          component: () => import('@/views/policy/PolicyList')
        },
        {
          path: '/policy/search',
          name: 'PolicySearch',
          component: () => import('@/views/policy/PolicySearch')
        },
        {
          path: '/policy/detail',
          name: 'PolicyDetail',
          component: () => import('@/views/policy/PolicyDetail')
        },
        {
          path: '/community/community',
          name: 'Community',
          meta: {
            keepAlive: true
          },
          component: () => import('@/views/community/community')
        },
        {
          path: '/community/communityDetail',
          name: 'CommunityDetail',
          component: () => import('@/views/community/communityDetail')
        },
        {
          path: '/showPic',
          name: 'showPic',
          component: () => import('@/views/showPic/index')
        },
        {
          path: '/file',
          name: 'File',
          component: () => import('@/views/file-view/file')
        },
        {
          path: '/fileView',
          name: 'fileView',
          component: () => import('@/views/file-view/fileNoHeader')
        },
        {
          path: '/showFiles',
          name: 'ShowFiles',
          component: () => import('@/views/file-view/showFiles')
        },
        {
          path: '/showVideos',
          name: 'ShowVideos',
          component: () => import('@/views/showVideos/index')
        },
        {
          path: '/showMap',
          name: 'showMap',
          component: () => import('@/views/showMap')
        },
        {
          path: '/showWifi',
          name: 'showWifi',
          component: () => import('@/views/showWifi')
        },
        {
          path: '/showAudios',
          name: 'ShowAudios',
          component: () => import('@/views/showAudios')
        },
        {
          path: '/showMecard',
          name: 'ShowMecard',
          component: () => import('@/views/showMecard')
        },
        {
          path: '/showBMecard',
          name: 'ShowBusinessMecard',
          component: () => import('@/views/showBMecard')
        },
        {
          path: '/showText',
          name: 'showText',
          component: () => import('@/views/showText')
        },
        {
          path: '/showUrl',
          name: 'showUrl',
          component: () => import('@/views/showUrl')
        },
        {
          path: '/showUrl2',
          name: 'showUrl2',
          component: () => import('@/views/showUrl/iframe')
        },
        {
          path: '/showPhone',
          name: 'showPhone',
          component: () => import('@/views/showPhone')
        },
        {
          path: '/search',
          name: 'searchHome',
          component: () => import('@/views/search')
        },
        {
          path: '/search/searchMain',
          name: 'searchMain',
          component: () => import('@/views/search/search-main')
        },
        {
          path: '/policy/manage',
          name: 'PolicyManage',
          component: () => import('@/views/policy/manage/PolicyManage')
        },
        {
          path: '/login',
          name: 'login',
          component: () => import('@/views/login/login')
        },
        {
          path: '/register',
          name: 'register',
          component: () => import('@/views/login/register')
        },
        {
          path: '/policy/manage/preview',
          name: 'PolicyPreview',
          component: () => import('@/views/policy/manage/PolicyPreview')
        },
        {
          path: '/policy/manage/list',
          name: 'PolicyManageList',
          component: () => import('@/views/policy/manage/PolicyManageList')
        },
        {
          path: '/homePage',
          redirect: '/home'
        },
        {
          path: '/',
          redirect: '/home'
        },
        {
          path: '/userInfo',
          name: 'userInfo',
          component: () => import('@/views/userInfo')
        },
        {
          path: '/createQr',
          name: 'createQr',
          meta: {
            keepAlive: true
          },
          component: () => import('@/views/home-page/createQr')
        },
        {
          path: '/formView',
          name: 'templateForm',
          component: () => import('@/views/home-page/components/templateForm')
        },
        {
          path: '/mf',
          name: 'mf',
          component: () => import('@/views/showForm')
        },
        {
          path: '/form/mf',
          name: 'formMf',
          component: () => import('@/views/form/mobile')
        },
        {
          path: '/form/mfv',
          name: 'formMfv',
          component: () => import('@/views/form/mobile-view')
        },
        {
          path: '/audioRecord',
          name: 'audioRecord',
          component: () => import('@/views/home-page/audioRecord')
        },
        {
          path: '/fileManage',
          name: 'fileManage',
          component: () => import('@/views/file-manage/index')
        },
        {
          path: '/checkPerm',
          name: 'checkPerm',
          component: () => import('@/views/checkPerm/index')
        },
        {
          path: '/secondNode',
          name: 'secondNode',
          component: () => import('@/views/second-nodes-manage/index')
        },
        {
          path: '/feedBack',
          name: 'feedBack',
          component: () => import('@/views/feedBack/index')
        },
        {
          path: '/zttComm',
          name: 'zttCommIndex',
          component: () => import('@/views/ztt-comm/index')
        },
        {
          path: '/zttComm/info',
          name: 'zttCommInfo',
          component: () => import('@/views/ztt-comm/commInfo')
        },
        {
          path: '/zttComm/pc',
          name: 'zttCommPCIndex',
          component: () => import('@/views/ztt-comm/pc/index')
        },
        {
          path: '/zttComm/pc/info',
          name: 'zttCommPCInfo',
          component: () => import('@/views/ztt-comm/pc/commInfo')
        },
        {
          path: '/c/:id',
          name: 'codeJump',
          component: () => import('@/views/codeJump/index')
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js